import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { getMobileOS } from "../../../utils/detect-mobile";
import { debounce } from "../../../utils/timed-functions";
import cx from "../styles";
export var View = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(View, _React$PureComponent);
  var _super = _createSuper(View);
  function View() {
    var _this;
    _classCallCheck(this, View);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onContainerScroll", function () {
      if (_this.props.onScroll) {
        _this.props.onScroll({
          scrollLeft: _this.container.scrollLeft,
          scrollWidth: _this.container.scrollWidth,
          offsetWidth: _this.container.offsetWidth,
          gutterHorizontal: _this.state.gutterHorizontal
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onResize", debounce(function () {
      _this.updateGutter();
      _this.onContainerScroll();
    }, 50));
    _defineProperty(_assertThisInitialized(_this), "container", null);
    _defineProperty(_assertThisInitialized(_this), "content", null);
    _defineProperty(_assertThisInitialized(_this), "bindContent", function (ref) {
      _this.content = ref;
      _this.updateGutter();
    });
    _defineProperty(_assertThisInitialized(_this), "bindContainer", function (ref) {
      _this.container = ref;
      _this.updateGutter();
    });
    _defineProperty(_assertThisInitialized(_this), "buildPadding", function () {
      return "".concat(_this.state.gutterVertical, "px ").concat(_this.state.gutterHorizontal, "px");
    });
    _defineProperty(_assertThisInitialized(_this), "updateGutter", debounce(function () {
      if (!(_this.container && _this.content)) {
        return;
      }
      var gutterHorizontal = _this.state.isNative || _this.scrollWidth === 0 ? 0 : _this.props.gutter;
      var gutterVertical = _this.state.isNative || _this.scrollHeight === 0 ? 0 : _this.props.gutter;
      var deltaHorizontal = gutterHorizontal - _this.state.gutterHorizontal;
      var deltaVertical = gutterVertical - _this.state.gutterVertical;
      var isScrollable = gutterHorizontal + gutterVertical !== 0;
      _this.setState({
        gutterHorizontal: gutterHorizontal,
        gutterVertical: gutterVertical,
        isScrollable: isScrollable
      }, function () {
        return _this.move(deltaHorizontal + _this.container.scrollLeft, deltaVertical + _this.container.scrollTop);
      });
    }, 50));
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: cx('scrollContainer', {
          draggable: _this.state.isScrollable,
          native: _this.state.isNative
        }, _this.props.className),
        onDragStart: function onDragStart(ev) {
          ev.preventDefault();
          return false;
        },
        onMouseDown: _this.handleMouseDown,
        onTouchStart: _this.handleTouchStart,
        ref: _this.bindContainer,
        role: "presentation"
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('content')
      }, /*#__PURE__*/React.createElement("div", {
        ref: _this.bindContent,
        style: {
          padding: _this.buildPadding()
        }
      }, _this.props.children), /*#__PURE__*/React.createElement("div", {
        className: cx('clickCatcher', {
          catch: _this.state.controlling
        })
      })));
    });
    return _this;
  }
  _createClass(View, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.setState({
        isNative: getMobileOS()
      });
      this.updateGutter();
      this.container.addEventListener('scroll', this.onContainerScroll);
      this.onContainerScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        isNative: getMobileOS()
      });
      window.removeEventListener('resize', this.onResize);
      this.container.removeEventListener('scroll', this.onContainerScroll);
    }
  }, {
    key: "contentWidth",
    get: function get() {
      return this.content ? this.content.clientWidth : 0;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.content ? this.content.clientHeight : 0;
    }
  }, {
    key: "containerWidth",
    get: function get() {
      return this.container ? this.container.clientWidth : 0;
    }
  }, {
    key: "containerHeight",
    get: function get() {
      return this.container ? this.container.clientHeight : 0;
    }
  }, {
    key: "scrollWidth",
    get: function get() {
      return Math.max(0, this.contentWidth - this.containerWidth);
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return Math.max(0, this.contentHeight - this.containerHeight);
    }
  }]);
  return View;
}(React.PureComponent);
_defineProperty(View, "defaultProps", {
  gutter: 25
});
_defineProperty(View, "getInitialState", function () {
  return {
    controlling: false,
    isScrollable: false,
    isNative: false,
    gutterHorizontal: 0,
    gutterVertical: 0
  };
});
_defineProperty(View, "state", View.getInitialState());
View.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  gutter: PropTypes.number,
  className: PropTypes.string
} : {};